export default "__VITE_PUBLIC_ASSET__3a569ad3__"